import { request } from './client';
import type { Branding } from '../types';

/** The portal's name and pictures. Contract: docs/api/BRANDING.md. */
export const brandingApi = {
  /** Open to anyone: the sign-in page shows it. */
  get: () => request<Branding>('/branding', {}, { keepPage: true }),

  save: (branding: Pick<Branding, 'brandName' | 'appName' | 'logo' | 'backdrop' | 'showName'>) =>
    request<Branding>('/branding', { method: 'PUT', body: JSON.stringify(branding) }),
};
